export const featureFlags = {
  chatDebug: true
} as const
